import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leaves-view',
  templateUrl: './leaves-view.component.html',
  styleUrls: ['./leaves-view.component.css']
})
export class LeavesViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
